import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import {obtenerHabitacionesOcupadasEntreFechas} from "../Controladores/obtenerHabitacionesOcupadasEntreFechas";
import {obtenerFechaEstandarCheckOut} from "./obtenerFechaEstandarCheckOut";
import {obtenerFechaEstandarCheckIn} from "./obtenerFechaEstandarCheckIn";

export const obtenerHabitacionesDisponibles = async ({fechaCheckIn, fechaCheckOut}) => {

    let w = [where('estado', '==', 'Libre')]
    let doxHabitaciones = await obtenerColWheres({wheres: w, col: 'habitaciones'})
    let habitaciones = doxHabitaciones.data

    let habitacionesOcupadas = await obtenerHabitacionesOcupadasEntreFechas({
        fechaCheckIn: obtenerFechaEstandarCheckIn(fechaCheckIn),
        fechaCheckOut: obtenerFechaEstandarCheckOut(fechaCheckOut),
    })

    let arr = habitaciones.filter((e) => !habitacionesOcupadas.includes(e.numero))

    return arr


}